import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useConfiguration } from '../../context/configurationContext';
import loadable from '@loadable/component';

// FairwayBid: Der Footer enthaelt Werbelinks, die zur Registrierung fuehren.
// Wer angemeldet ist, soll die nicht mehr sehen – Rechtliches bleibt fuer alle.
import { getAudience, filterFooterMarkdown, ANONYMOUS } from '../../fairwaybid/audience';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);

const FooterComponent = props => {
  const { currentUser } = props;
  const { footer = {}, topbar } = useConfiguration();

  // Der Server rendert ohne angemeldeten Nutzer. Damit die Hydration nicht
  // auf zwei verschiedene Baeume trifft, filtern wir erst nach dem Mounten.
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  // If footer asset is not set, let's not render Footer at all.
  if (Object.keys(footer).length === 0) {
    return null;
  }

  const audience = hasMounted ? getAudience(currentUser) : ANONYMOUS;
  const blocks = Array.isArray(footer.blocks)
    ? footer.blocks.map(block => {
        const content = block?.text?.content;
        if (typeof content !== 'string') return block;
        return { ...block, text: { ...block.text, content: filterFooterMarkdown(content, audience) } };
      })
    : footer.blocks;

  // The footer asset does not specify sectionId or sectionType. However, the SectionBuilder
  // expects sectionId and sectionType in order to identify the section. We add those
  // attributes here before passing the asset to SectionBuilder.
  const footerSection = {
    ...footer,
    blocks,
    sectionId: 'footer',
    sectionType: 'footer',
    linkLogoToExternalSite: topbar?.logoLink,
  };

  return <SectionBuilder sections={[footerSection]} />;
};

const mapStateToProps = state => {
  const { currentUser } = state.user || {};
  return { currentUser };
};

const FooterContainer = compose(connect(mapStateToProps))(FooterComponent);

export default FooterContainer;
